





















import { Component, Vue, Prop } from "vue-property-decorator";
import { Recommend } from "@/req/user";
@Component
export default class Home extends Vue {
  @Prop({
    default() {
      return [];
    },
    type: Array,
  })
  public recommendList;
  @Prop({type: Number, default: -1 }) public recommendActive;
  public row = 7;
  public recommendAct(index) {
    // this.recommendActive = index;
    this.$emit("activeIdx", index)
  }
  public async submit() {
    const imgObj = this.recommendList.filter((item) => {
      return item.id === this.recommendActive;
    });
    this.$emit("submitAvator", 0, imgObj[0]);
    /* const res = await Recommend({
      token: this.$fn.cookies.getToken("token"),
      img_id: this.recommendList[this.active].id,
    });
    if (res.code === 200) {
      this.$Message.success(res.msg);
      this.$emit("getUserInfo");
    } */
  }
}
